<template>

  <b-modal size="lg" v-model="value" @click.prevent="closeShipmentModel" title="Confirmation" >
    <div role="document" style="">
      <div class="modal-content" >
        <div class="modal-headerfrm">
          <h4 class="modal-title">Bulk Update Status Report</h4>
          <button type="button" class="close" @click.prevent="closeShipmentModel" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-bodyfrm">
          <div class="row">
            <div class="col-md-12">
              <div class="suggestion">
                <div class="radius">
                  <label class="text-muted"> Success </label>
                  <span class="dotSuccess"></span>
                </div>
                <div class="radius">
                  <label class="text-muted"> Error </label>
                  <span class="dotError"></span>
                </div>
              </div>
              <vue-element-loading spinner="line-scale" color="#FF6700" :active.sync="isForwardBulkReportLoader" />
              <table class="b-table table table-bordered" style="width:100%">
                  <thead class="thead-default">
                  <tr>
                    <th>Sr No.</th>
                    <th>Shipping ID</th>
                    <th> Message </th>
                  </tr>
                  </thead>
                  <tbody>
                    <template v-if="Object.keys(this.showForwardBulkReportStatus).length > 0">
                      <tr v-for="(value, propertyName, index) in showForwardBulkReportStatus" :class="[value.code == 200 ? 'applysuccess' : 'applyErrorcss' ]" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{propertyName}}</td>
                        <td>{{ value.message }}</td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="3" align="center">No record found</td>
                      </tr>
                    </template>
                  </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footerfrm mt-4" style="float:right">
          <button type="button" class="btn btn-danger" data-dismiss="modal" @click.prevent="closeShipmentModel()">close</button>
        </div>
      </div>
    </div>
  </b-modal>
</template>


<script>
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'ForwardBulkPodResultStatus',
  components: {
    VueElementLoading
  },
  data: function() {
    return{

    }
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    showForwardBulkReportStatus: {
      type: Object,
      required: true,
    },
    isForwardBulkReportLoader: {
      type: Boolean,
      required: true,
    }
  },
  methods: {
    closeShipmentModel(){
      this.$emit("input", !this.value);
    }
  }
}

</script>

<style lang="css" scoped>
/* .applyErrorcss{
  background-color: red;
} */
.applyErrorcss td {
  color: #f86c6b;
  font-weight: bold;
}
.applysuccess td {
  color: #4dbd74;
  font-weight: bold;
}
.dotSuccess {
  height: 15px;
  width: 15px;
  background-color: #4dbd74;
  border-radius: 50%;
  display: inline-block;
}
.dotError {
  height: 15px;
  width: 15px;
  background-color: #f86c6b;
  border-radius: 50%;
  display: inline-block;
}
.radius {
  float: left;
  margin-right: 10px;
}
.radius .text-muted{
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/components/common/ForwardBulkPodResultStatus.vue?7094ef38